module.exports = __webpack_public_path__ + "img/flower_leaf_12.b827c0cc.png";